export function getEnvironment() {
  const raw = process.env.REACT_APP_ENV || process.env.NODE_ENV || "development";

  if (raw.startsWith("dev")) return "DEV";
  if (raw.startsWith("prod")) return "PROD";

  return raw.toUpperCase(); // fallback
}